import {
  TradingLeaderboardInterval,
  TradingLeaderboardLeague,
  TradingLeaderboardTier,
} from '@flipster/apis/v2/trading-leaderboards/types';

export const tradingLeaderboardLeagues: TradingLeaderboardLeague[] = ['NORMAL', 'MASTER'];
export const tradingLeaderboardIntervals: TradingLeaderboardInterval[] = ['WEEKLY', 'MONTHLY'];
export const tradingLeaderboardTiers: TradingLeaderboardTier[] = ['ALL', 'WHALE', 'SHARK', 'STARTER'];

export interface IntervalInformation {
  label: string;
}
export const intervalInfos: Record<TradingLeaderboardInterval, IntervalInformation> = {
  WEEKLY: {
    label: 'week',
  },
  MONTHLY: {
    label: 'month',
  },
};

export interface TierInformation {
  label: string;
}
export const tierInfos: Record<TradingLeaderboardTier, TierInformation> = {
  ALL: {
    label: 'All',
  },
  WHALE: {
    label: 'Whale',
  },
  SHARK: {
    label: 'Shark',
  },
  STARTER: {
    label: 'Starter',
  },
};
